import gsap from "gsap";
export default {
  data() {
    return {
    };
  },
  mounted() {
    let helpList=[]
    this.$store.commit("setHelpIndex",0)
    for(var i in this.helps){
      this.getHelp(this.helps[i].id,this.helps[i])
      helpList.push(this.helps[i].id)
    }
    this.$store.commit("setHelpList",helpList)
  },

  computed: {
    shownHelps(){
      return this.$store.getters.getShownHelps
    }
    
  },
  methods: {
    async getHelp(helpID){
      await this.$store.dispatch("retreiveText",{type:"Help",element:helpID})
      let help=this.$store.getters.getTextElement({collection:"Help",doc:helpID})
      help.id=helpID
      help.shown=false
      this.$store.commit('addHelp',help)
   },
   
   showHelp(){
     let nextHelp=this.$store.getters.getNextHelp
     if(nextHelp){
      nextHelp.shown=true
      if(!this.shownHelps.includes(nextHelp.id)){
        this.$store.dispatch("showNextHelp",nextHelp)
      }
      this.$store.dispatch("nextHelp")
     }
     
   },
   
   stopHelp(){
    gsap.killTweensOf(this.showHelp)
    this.$store.dispatch("stopHelp")
  },
  }
  
}